// extracted by mini-css-extract-plugin
export default {"container":"_QQtHO","title":"Vby69H","button":"hg2Ly1","titleV2":"KjUDTM","bannerText":"alXvj3"};